import { Form, Formik } from 'formik'
import { observer } from 'mobx-react-lite'
import React, { useState, useContext } from 'react'
import { useParams } from 'react-router-dom'
import { CampaignContext } from '../../../../../../../contexts/CampaignContext'
import { InfluencerPayoutMarginSchema } from '../../../../../../../schemas/ProjectManager/MarginSchema'
import axiosService from '../../../../../../../utils/AxiosService'
import Input from '../../../../../../FormComponents/Input'
import { toastError, toastSuccess } from '../../../../../../FormComponents/Toasts'
import { useReadOnly } from '../../../../../../../contexts/ReadOnlyContext'

export default observer(function InfluencerPayoutMarginField({ action }) {
  const readOnly = useReadOnly()
  const { id } = useParams()
  const { primaryScenarioId } = useContext(CampaignContext)
  const [currentTimeout, setCurrentTimeout] = useState(null)

  const changeMargin = influencer_payout_margin => {
    if (currentTimeout) clearTimeout(currentTimeout)
    setCurrentTimeout(setTimeout(() => submitAdvertiserMargin(influencer_payout_margin), 1000))
  }

  const handleFormSubmit = values => {
    if (currentTimeout) clearTimeout(currentTimeout)
    const value = typeof values?.influencer_payout_margin === 'object'
      ? values.influencer_payout_margin?.influencer_payout_margin
      : values?.influencer_payout_margin
    submitAdvertiserMargin(value)
  }

  const submitAdvertiserMargin = influencer_payout_margin => {
    axiosService.patch(`/api/project_manager/campaigns/${id}/campaign_scenarios/${primaryScenarioId}/actions/${action.id}`, { campaign_scenario_action: { influencer_payout_margin }})
    .then((updatedAction) => {
      toastSuccess('Margin updated')
      action.influencer_payout_margin = updatedAction.influencer_payout_margin
    })
    .catch(({ data: { error }}) => toastError(error))
  }

  return (
    <Formik
      key={action.influencer_payout_margin}
      initialValues={{ influencer_payout_margin: action.influencer_payout_margin }}
      validationSchema={InfluencerPayoutMarginSchema}
      onSubmit={handleFormSubmit}
    >
      {({ errors, touched, handleBlur, handleChange, values }) => (
        <Form className="w-full">
          <div className="relative">
            <Input
              disabled={readOnly}
              addon="%"
              addonPosition="end"
              error={touched.influencer_payout_margin && errors.influencer_payout_margin}
              name="influencer_payout_margin"
              noLabelPadding
              onChange={(e) => {
                changeMargin(e.target.value)
                handleChange(e)
              }}
              onBlur={handleBlur}
              value={values.influencer_payout_margin}
              overrideClassName="h-7"
              topMargin="mt-0"
            />
          </div>
        </Form>
      )}
    </Formik>
  )
})